module.exports = __webpack_public_path__ + "static/homescreenIllustration-dafd611844531a1c283fe4b56f73866c.svg";